import { newValidator, validateNotBlank, validateEmail } from 'simple-valley'
import { dayValidator, monthValidator, yearValidator } from '@Pass-It-Down/passitdown-utils'

export function validateInputNotBlank(data, key) {
  let v = newValidator(data)
  v = validateNotBlank(v, key)
  return { isValid: v.isValid }
}

export function validateUserEmail(data, key) {
  let v = newValidator(data)
  v = validateEmail(v, key)
  return { isValid: v.isValid }
}


export function decadesValidator(decade) {
  if (decade === 'Select') return { isValid: true, message: undefined }
  return validateYear(decade)
}

export function validateYear(year) {
  if (!year) return { isValid: true, message: undefined }

  year = parseInt(year)
  if (isNaN(year)) return { isValid: false, message: 'invalid year' }

  let v = newValidator({ year })
  v = yearValidator(v)

  return { isValid: v.isValid, message: v.messages[0]?.message }
}

export function validateMonth(month) {
  if (!month) return { isValid: true, message: undefined }

  month = parseInt(month)
  if (isNaN(month)) return { isValid: false, message: 'invalid month' }

  let v = newValidator({ month })
  v = monthValidator(v)

  return { isValid: v.isValid, message: v.messages[0]?.message }
}

export function validateDay(day) {
  if (!day) return { isValid: true, message: undefined }

  day = parseInt(day)

  let v = newValidator({ day })
  v = dayValidator(v)

  return { isValid: v.isValid, message: v.messages[0]?.message }
}